import React from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

type MetadataProps = StylableComponent<HTMLDivElement> & {
  disabled?: boolean;
};

const Metadata = React.forwardRef<HTMLDivElement, MetadataProps>(
  ({ className, style, disabled, children, ...props }, ref) => {
    const theme = useTheme();
    const metadataTokens = theme.tokens?.component?.fileHandler?.metadata;

    return !disabled && children ? (
      <div
        ref={ref}
        className={className}
        css={[metadataTokens, style]}
        {...props}
      >
        <OverflowTooltip>{children}</OverflowTooltip>
      </div>
    ) : null;
  },
);

Metadata.displayName = 'Metadata';

Metadata.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** If the file is disabled (removed or loading variant) */
  disabled: PropTypes.bool,
  children: PropTypes.any,
};

export default Metadata;
